handleUserAvailabilityResponse